// extracted by mini-css-extract-plugin
module.exports = {"monthInfo":"_1aTlGY"};